import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import styles from "../style/registration.module.css";
import { ReactComponent as ClickedRadio } from "../assets/image/clicked-radio-button.svg";
import { ReactComponent as UnClickedRadio } from "../assets/image/unclicked-radio-button.svg";

import { useState } from "react";
import Helmet from "react-helmet";
import thankYouImg from "../assets/image/thank-you.png";
import goBackIcon from "../assets/image/goback-white-arrow.svg";
import { Link } from "react-router-dom";
import { bloodDriveLocations } from "../data/bloodDriveLocations";

const Registration = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    gender: "",
    phone: "",
    donated: "",
    location: "",
    dob: "",
    comments: "",
    conditions: "",
    weight: "",
  });

  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    let error = "";
    if (!value.trim()) {
      error = `${name} is required`;
    }
    if (name === "email" && value && !/^\S+@\S+\.\S+$/.test(value)) {
      error = "Enter a valid email";
    }

    if (name === "phone" && value && !/^\d{10}$/.test(value)) {
      error = "Enter a 10-digit phone number, not 11";
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    const error = validateField(name, value);

    setErrors((prev) => {
      const updated = { ...prev };
      if (error) {
        updated[name] = error;
      } else {
        delete updated[name]; // ✅ remove cleared error
      }
      return updated;
    });
  };

  const [isSubmitted, setIsSubmitted] = useState(false); //should be false

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loading

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (key === "weight") return; // skip validation for weight fields
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const encodedData = new URLSearchParams(formData).toString();
      try {
        await fetch(
          "https://script.google.com/macros/s/AKfycbw_w9JQfNRGjR52Ie6SpYKQAS4_sHGt0h3xTkfJSE0t5JA5V8a2fwOzRwfLnFOZtPTS/exec",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: encodedData,
          }
        );

        setIsSubmitted(true);
      } catch (error) {
        console.error("Submission failed:", error);
      }
    }

    setLoading(false); // Hide loading
  };

  const handleResetForm = () => {
    // Reset form data
    setFormData({
      name: "",
      email: "",
      gender: "",
      phone: "",
      donated: "",
      location: "",
      dob: "",
      comments: "",
      conditions: "",
      weight: "",
    });

    // Clear errors
    setErrors({});

    // Show the form again
    setIsSubmitted(false);
  };

  const generateLocationsString = () => {
    // Extract LGA names and clean them up
    const lgaNames = bloodDriveLocations.map((location) => {
      // Remove "LGA" from the end and clean up
      return location.lga.replace(" LGA", "").trim();
    });

    // Join with commas and "and" before the last item
    if (lgaNames.length === 0) return "";
    if (lgaNames.length === 1) return lgaNames[0];

    const allButLast = lgaNames.slice(0, -1);
    const lastLGA = lgaNames[lgaNames.length - 1];

    return `${allButLast.join(", ")}, and ${lastLGA} LGAs`;
  };

  return (
    <div className="register">
      {!isSubmitted ? (
        <div className="registrationPage">
          <Helmet>
            <title>Register - Your Power to Gift Life</title>
            <meta
              name="description"
              content="Sign up to join thousands donating blood across Lagos."
            />
          </Helmet>
          {/*    NAV   */}
          <Navbar isRegistrationPage={true} />

          <div
            className={styles.registrationHero}
            style={{
              backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)), url('/assets/background-Image/dots-background.webp')`,
            }}
          >
            <div className={styles.registrationSection}>
              <div className={styles.registrationDetails}>
                <h3>Registration Form</h3>
                <p>
                  Thank you for your willingness to donate blood. Our upcoming
                  blood donation drive spans {bloodDriveLocations.length}{" "}
                  locations: {generateLocationsString()}. Please complete this
                  form to register as a donor. We will contact you with details
                  about your preferred location, date, and time.
                </p>
              </div>
              <form action="" onSubmit={handleSubmit}>
                <div className={styles.formTopLayout}>
                  <div className={styles.formTopLayoutLeft}>
                    {/*        FULL NAME          */}

                    <div className={styles.inputLayout}>
                      <label htmlFor="name" className={styles.labelHead}>
                        Full Name:
                      </label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter your full name"
                        id="name"
                        value={formData.name}
                        onChange={handleChange}
                        style={{
                          border: errors.name
                            ? " 0.4px solid rgba(236, 0, 0, 0.1)"
                            : "0.4px solid rgba(0, 0, 0, 0.1)",
                          background: errors.name
                            ? "rgba(236, 0, 0, 0.02)"
                            : "rgba(10, 10, 10, 0.02)",
                        }}
                      />
                      {errors.name && (
                        <p
                          className={styles.errorMessage}
                          style={{ color: "red" }}
                        >
                          Full name is required
                        </p>
                      )}
                    </div>

                    {/*        EMAIL          */}

                    <div className={styles.inputLayout}>
                      <label htmlFor="email" className={styles.labelHead}>
                        Email Address:
                      </label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your Email address"
                        id="email"
                        value={formData.email}
                        onChange={handleChange}
                        style={{
                          border: errors.email
                            ? " 0.4px solid rgba(236, 0, 0, 0.1)"
                            : "0.4px solid rgba(0, 0, 0, 0.1)",
                          background: errors.email
                            ? "rgba(236, 0, 0, 0.02)"
                            : "rgba(10, 10, 10, 0.02)",
                        }}
                      />
                      {errors.email && (
                        <p
                          className={styles.errorMessage}
                          style={{ color: "red" }}
                        >
                          Enter a valid email
                        </p>
                      )}
                    </div>

                    {/*         GENDER         */}

                    <div className={styles.inputLayout}>
                      <label htmlFor="" className={styles.labelHead}>
                        Gender:
                      </label>
                      <label htmlFor="male">
                        {/* <img
                          src={
                            formData.gender === "male"
                              ? clickedRadio
                              : unClickedRadio
                          }
                          alt="radio"
                        /> */}
                        {formData.gender === "male" ? (
                          <ClickedRadio className={styles.img} />
                        ) : (
                          <UnClickedRadio className={styles.img} />
                        )}
                        Male
                        <input
                          type="radio"
                          name="gender"
                          value="male"
                          id="male"
                          onChange={handleChange}
                          checked={formData.gender === "male"}
                        />
                      </label>
                      <label htmlFor="female">
                        {/* <img
                          src={
                            formData.gender === "female"
                              ? clickedRadio
                              : unClickedRadio
                          }
                          alt="radio"
                        /> */}
                        {formData.gender === "female" ? (
                          <ClickedRadio className={styles.img} />
                        ) : (
                          <UnClickedRadio className={styles.img} />
                        )}
                        Female
                        <input
                          type="radio"
                          name="gender"
                          value="female"
                          id="female"
                          onChange={handleChange}
                          checked={formData.gender === "female"}
                        />
                      </label>
                      <label htmlFor="other">
                        {/* <img
                          src={
                            formData.gender === "other"
                              ? clickedRadio
                              : unClickedRadio
                          }
                          alt="radio"
                        /> */}
                        {formData.gender === "other" ? (
                          <ClickedRadio className={styles.img} />
                        ) : (
                          <UnClickedRadio className={styles.img} />
                        )}
                        Other
                        <input
                          type="radio"
                          name="gender"
                          value="other"
                          id="other"
                          onChange={handleChange}
                          checked={formData.gender === "other"}
                        />
                      </label>
                      {errors.gender && (
                        <p
                          className={styles.errorMessage}
                          style={{ color: "red" }}
                        >
                          Gender is required
                        </p>
                      )}
                    </div>

                    {/* MEDICAL CONDITIONS */}

                    <div className={styles.inputLayout}>
                      <label htmlFor="conditions" className={styles.labelHead}>
                        Do you have any known medical conditions?{" "}
                      </label>
                      <textarea
                        id="conditions"
                        name="conditions"
                        rows="7"
                        cols="50"
                        placeholder="Please indicate any chronic illnesses, recent surgeries, or health concerns"
                        value={formData.conditions}
                        onChange={handleChange}
                        style={{
                          border: errors.conditions
                            ? " 0.4px solid rgba(236, 0, 0, 0.1)"
                            : "0.4px solid rgba(0, 0, 0, 0.1)",
                          background: errors.conditions
                            ? "rgba(236, 0, 0, 0.02)"
                            : "rgba(10, 10, 10, 0.02)",
                        }}
                      ></textarea>
                      {errors.conditions && (
                        <p
                          className={styles.errorMessage}
                          style={{ color: "red" }}
                        >
                          Input is required
                        </p>
                      )}
                    </div>
                  </div>

                  <div className={styles.formTopLayoutRight}>
                    {/*     PHONE NUMBER     */}
                    <div className={styles.inputLayout}>
                      <label htmlFor="phone" className={styles.labelHead}>
                        Phone Number <span>(WhatsApp preferred)</span> :
                      </label>
                      <div
                        className={styles.contactLayout}
                        style={{
                          border: errors.phone
                            ? " 0.4px solid rgba(236, 0, 0, 0.1)"
                            : "0.4px solid rgba(0, 0, 0, 0.1)",
                          background: errors.phone
                            ? "rgba(236, 0, 0, 0.02)"
                            : "rgba(10, 10, 10, 0.02)",
                        }}
                      >
                        <p>+234</p>
                        <input
                          type="text"
                          name="phone"
                          placeholder=""
                          id="phone"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.phone && (
                        <p
                          className={styles.errorMessage}
                          style={{ color: "red" }}
                        >
                          Enter valid phone number
                        </p>
                      )}
                    </div>

                    {/*        DATE OF BIRTH      */}
                    <div className={styles.inputLayout}>
                      <label htmlFor="date" className={styles.labelHead}>
                        Date Of Birth:
                      </label>
                      <input
                        type="date"
                        name="dob"
                        placeholder="dd/mm/yyyy"
                        id="date"
                        value={formData.dob}
                        onChange={handleChange}
                        style={{
                          border: errors.dob
                            ? " 0.4px solid rgba(236, 0, 0, 0.1)"
                            : "0.4px solid rgba(0, 0, 0, 0.1)",
                          background: errors.dob
                            ? "rgba(236, 0, 0, 0.02)"
                            : "rgba(10, 10, 10, 0.02)",
                        }}
                      />
                      {errors.dob && (
                        <p
                          className={styles.errorMessage}
                          style={{ color: "red" }}
                        >
                          Date of birth is required
                        </p>
                      )}
                    </div>

                    {/* WEIGHT */}

                    <div className={styles.inputLayout}>
                      <label htmlFor="weight" className={styles.labelHead}>
                        Weight <span>(optional)</span>:
                      </label>
                      <div className={styles.weightLayout}>
                        <input
                          type="number"
                          name="weight"
                          placeholder=""
                          id="weight"
                          value={formData.weight}
                          onChange={handleChange}
                        />
                        <p>Kg</p>
                      </div>
                    </div>

                    {/*         DONATED        */}
                    <div className={styles.inputLayout}>
                      <label htmlFor="" className={styles.labelHead}>
                        Have you donated blood before?:
                      </label>
                      <label htmlFor="yes">
                        {/* <img
                          alt="radio"
                          src={
                            formData.donated === "yes"
                              ? clickedRadio
                              : unClickedRadio
                          }
                        /> */}
                        {formData.donated === "yes" ? (
                          <ClickedRadio className={styles.img} />
                        ) : (
                          <UnClickedRadio className={styles.img} />
                        )}
                        Yes
                        <input
                          type="radio"
                          name="donated"
                          value="yes"
                          id="yes"
                          onChange={handleChange}
                          checked={formData.donated === "yes"}
                        />
                      </label>
                      <label htmlFor="no">
                        {/* <img
                          src={
                            formData.donated === "no"
                              ? clickedRadio
                              : unClickedRadio
                          }
                          alt="radio"
                        /> */}
                        {formData.donated === "no" ? (
                          <ClickedRadio className={styles.img} />
                        ) : (
                          <UnClickedRadio className={styles.img} />
                        )}
                        No
                        <input
                          type="radio"
                          name="donated"
                          value="no"
                          id="no"
                          onChange={handleChange}
                          checked={formData.donated === "no"}
                        />
                      </label>
                      {errors.donated && (
                        <p
                          className={styles.errorMessage}
                          style={{ color: "red" }}
                        >
                          Input is required
                        </p>
                      )}
                    </div>

                    {/*  COMMENTS  */}
                    <div className={styles.inputLayout}>
                      <label htmlFor="comments">
                        Additional Comments or Questions:
                      </label>
                      <textarea
                        id="comments"
                        name="comments"
                        rows="4"
                        cols="50"
                        placeholder="Let us know if you have specific concerns or questions"
                        value={formData.comments}
                        onChange={handleChange}
                        style={{
                          border: errors.comments
                            ? " 0.4px solid rgba(236, 0, 0, 0.1)"
                            : "0.4px solid rgba(0, 0, 0, 0.1)",
                          background: errors.comments
                            ? "rgba(236, 0, 0, 0.02)"
                            : "rgba(10, 10, 10, 0.02)",
                        }}
                      ></textarea>
                      {errors.comments && (
                        <p
                          className={styles.errorMessage}
                          style={{ color: "red" }}
                        >
                          Input is required
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* LOCATION */}
                <div
                  className={`${styles.inputLayout} ${styles.locationLayout}`}
                >
                  <label htmlFor="" className={styles.labelHead}>
                    Preferred Donation Location:
                  </label>

                  <label htmlFor="etiLGA">
                    {formData.location === "etiLGA" ? (
                      <ClickedRadio className={styles.img} />
                    ) : (
                      <UnClickedRadio className={styles.img} />
                    )}
                    Eti- Osa LGA - Monarch Event Centre , Oba Elegushi
                    <input
                      type="radio"
                      name="location"
                      value="etiLGA"
                      id="etiLGA"
                      onChange={handleChange}
                      checked={formData.location === "etiLGA"}
                    />
                  </label>
                  <label htmlFor="ikejaLGA">
                    {formData.location === "ikejaLGA" ? (
                      <ClickedRadio className={styles.img} />
                    ) : (
                      <UnClickedRadio className={styles.img} />
                    )}
                    Ikeja LGA - Jara Mall
                    <input
                      type="radio"
                      name="location"
                      value="ikejaLGA"
                      id="ikejaLGA"
                      onChange={handleChange}
                      checked={formData.location === "ikejaLGA"}
                    />
                  </label>
                  <label htmlFor="ikoroduLGA">
                    {formData.location === "ikoroduLGA" ? (
                      <ClickedRadio className={styles.img} />
                    ) : (
                      <UnClickedRadio className={styles.img} />
                    )}
                    Ikorodu LGA -Ikorodu General Hospital{" "}
                    <input
                      type="radio"
                      name="location"
                      value="ikoroduLGA"
                      id="ikoroduLGA"
                      onChange={handleChange}
                      checked={formData.location === "ikoroduLGA"}
                    />
                  </label>
                  <label htmlFor="lagosIslandLGA">
                    {formData.location === "lagosIslandLGA" ? (
                      <ClickedRadio className={styles.img} />
                    ) : (
                      <UnClickedRadio className={styles.img} />
                    )}
                    Lagos Island LGA - Tinubu Square{" "}
                    <input
                      type="radio"
                      name="location"
                      value="lagosIslandLGA"
                      id="lagosIslandLGA"
                      onChange={handleChange}
                      checked={formData.location === "lagosIslandLGA"}
                    />
                  </label>
                  <label htmlFor="surulereLGA">
                    {formData.location === "surulereLGA" ? (
                      <ClickedRadio className={styles.img} />
                    ) : (
                      <UnClickedRadio className={styles.img} />
                    )}
                    Surulere LGA - Teslim Balogun Stadium{" "}
                    <input
                      type="radio"
                      name="location"
                      value="surulereLGA"
                      id="surulereLGA"
                      onChange={handleChange}
                      checked={formData.location === "surulereLGA"}
                    />
                  </label>
                  <label htmlFor="yabaLGA">
                    {formData.location === "yabaLGA" ? (
                      <ClickedRadio className={styles.img} />
                    ) : (
                      <UnClickedRadio className={styles.img} />
                    )}
                    Yaba LGA - Indoor sports center , UNILAG{" "}
                    <input
                      type="radio"
                      name="location"
                      value="yabaLGA"
                      id="yabaLGA"
                      onChange={handleChange}
                      checked={formData.location === "yabaLGA"}
                    />
                  </label>

                  {errors.location && (
                    <p className={styles.errorMessage} style={{ color: "red" }}>
                      Location is required
                    </p>
                  )}
                </div>
                <button
                  className={`${styles.submitButton} ${
                    Object.keys(errors).length > 0 ? styles.errorButton : ""
                  }`}
                  type="submit"
                  disabled={loading}
                >
                  {loading
                    ? "Submitting...Please Wait"
                    : Object.keys(errors).length > 0
                    ? "Incomplete Form!"
                    : "Submit"}
                </button>
              </form>
            </div>
          </div>

          {/* FOOTER */}

          <Footer></Footer>
        </div>
      ) : (
        <div className={styles.thankYou}>
          <div className={styles.thankYouImg}>
            <img src={thankYouImg} alt="thank you" />
          </div>
          <p>
            Thank you for registering! You are helping us save thousands of
            lives. We will reach out shortly with details about your donation
            appointment.
          </p>
          <p>
            Remember: Eat well, stay hydrated, and get a good rest before
            donation day!
          </p>
          <p>
            For more updates, you can join the{" "}
            <a
              href="https://chat.whatsapp.com/EOuovULHcqU8NQcUwQ9KTH?mode=ac_t"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.groupLink}
            >
              YPTGL group chat
            </a>
            .
          </p>
          <div className={styles.thankyouButtonLayout}>
            <Link to="/">
              <button className={styles.goBackBtn}>
                <img src={goBackIcon} alt="go back" />
                Go back to Homepage
              </button>
            </Link>
            <button className={styles.responseBtn} onClick={handleResetForm}>
              Submit another Response
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Registration;
